<template>
  <b-modal ref="order-modal"
           modal-class="task-modal v2-modal"
           hide-footer
  >
    <template #modal-header>
      <div class="v2-modal__head">
        <div class="v2-modal__titles">
          <div class="v2-modal__eyebrow">{{ $t('tasks.v2.objective.eyebrow') }}</div>
          <h3>{{ $t('tasks.v2.objective.reorder') }}</h3>
        </div>
        <span class="task-panel__nav" @click="hide" data-qid="objective-order-close"><font-awesome-icon icon="times"/></span>
      </div>
    </template>

    <p class="v2-assign__intro">{{ $t('tasks.v2.objective.reorder_hint') }}</p>
    <b-alert v-if="error" show variant="danger">{{ error }}</b-alert>

    <draggable v-model="items"
               handle=".objective-order__handle"
               ghost-class="ghost-row"
               class="objective-order"
               data-qid="objective-order-list"
    >
      <div v-for="(objective, index) in items" :key="'order-' + objective.id" class="objective-order__item">
        <span class="objective-order__handle"><font-awesome-icon icon="grip-vertical"/></span>
        <span class="objective-order__no">{{ index + 1 }}</span>
        <span class="objective-order__name">{{ objective.name }}</span>
        <span class="v2-field__icon" :class="{'disabled': index === 0}" @click="move(index, -1)"><font-awesome-icon icon="chevron-up"/></span>
        <span class="v2-field__icon" :class="{'disabled': index === items.length - 1}" @click="move(index, 1)"><font-awesome-icon icon="chevron-down"/></span>
      </div>
    </draggable>

    <div class="v2-modal__foot">
      <b-button variant="secondary" @click="hide" data-qid="objective-order-cancel">{{ $t('projects.create.cancel') }}</b-button>
      <b-button variant="success"
                :disabled="saving"
                @click="save"
                data-qid="objective-order-save"
      >{{ $t('tasks.modal.save') }}</b-button>
    </div>
  </b-modal>
</template>

<script>
import piincHttp from '@/util/configureAxios.js';
import draggable from 'vuedraggable';

// Put the control objectives of a project in a new order (drag, or the arrows)
export default {
  name: 'EngagementObjectiveOrderModal',
  props: {
    project: {
      type: Object,
      required: true
    }
  },
  components: {
    draggable
  },
  data() {
    return {
      items: [],
      error: '',
      saving: false
    };
  },
  methods: {
    show(objectives) {
      this.items = _.clone(objectives);
      this.error = '';
      this.$refs['order-modal'].show();
    },
    hide() {
      this.$refs['order-modal'].hide();
    },
    move(index, direction) {
      const target = index + direction;
      if (target < 0 || target >= this.items.length) {
        return;
      }
      const items = this.items.slice();
      items.splice(target, 0, items.splice(index, 1)[0]);
      this.items = items;
    },
    save() {
      let self = this;
      this.saving = true;
      piincHttp.post('project-control-objectives/order', {
        project_id: this.project.id,
        order: _.map(this.items, (objective, index) => ({ id: objective.id, position: index + 1 }))
      }).then(function() {
        self.saving = false;
        self.$toastr('success', self.$t('tasks.v2.list.order_saved'));
        self.$emit('saved');
        self.hide();
      }, function(error) {
        self.saving = false;
        self.error = error.data && error.data.message ? error.data.message : '';
      });
    }
  }
};
</script>
